import { useMemo, useRef } from 'react';

import { Typography, Icon } from '@material-ui/core';
import clsx from 'clsx';

import { LightTooltip } from 'components';

import { useStyles } from './styles';

interface LikertScaleProps {
  data?: number;
  scale?: number;
  bgColor?: string;
  noDataText?: string;
}

const defaultBackgroundColor = '#D582F9';
const defaultNoDataText = 'Não há dados';
const defaultScale = 5;

export function LikertScale({
  data,
  noDataText = defaultNoDataText,
  bgColor = defaultBackgroundColor,
  scale = defaultScale,
}: LikertScaleProps): JSX.Element {
  const classes = useStyles();
  const tooltipRef = useRef<HTMLDivElement | null>(null);

  const scaleDots = useMemo(() => {
    return Array(scale ?? 0)
      .fill(0)
      .map((_, index) => index + 1);
  }, [scale]);

  return (
    <LightTooltip
      title={`${data} de ${scale}`}
      open={!data ? false : undefined}
      placement="top-start"
    >
      <div
        className={clsx(classes.root, {
          [classes.dotsContainer]: data,
        })}
      >
        {data !== null && data !== undefined && (
          <>
            {scaleDots.map(dot => (
              <div
                key={dot}
                className={classes.dot}
                style={{
                  backgroundColor:
                    dot <= data ? bgColor ?? defaultBackgroundColor : undefined,
                }}
              />
            ))}
            <Typography variant="subtitle2" color="textPrimary">
              {data}
            </Typography>
          </>
        )}
        {(data === null || data === undefined) && (
          <div className={classes.noDataContainer}>
            <Typography variant="subtitle2" color="textSecondary">
              {noDataText}
            </Typography>
            <LightTooltip
              ref={tooltipRef}
              placement="top"
              title="Não houve respostas suficientes"
            >
              <Icon
                color="primary"
                fontSize="small"
                className={classes.noDataIcon}
              >
                info
              </Icon>
            </LightTooltip>
          </div>
        )}
      </div>
    </LightTooltip>
  );
}
